import { Component, Input } from '@angular/core';
import { HygieneStaftReportService } from '../hygiene-staft-report.service';
export interface SidebarItem {
  path: string;
  label: string;
  icon: string;
}

export interface SidebarSection {
  title: string;
  items: SidebarItem[];
}
@Component({
  selector: 'app-hygine-sidebar',
  templateUrl: './hygine-sidebar.component.html',
  styleUrls: ['./hygine-sidebar.component.scss']
})
export class HygineSidebarComponent {
  @Input() hkdbTheme: 'dark' | 'light' | null = null;
  private collapseTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly collapseDelayMs = 200;
  payrollIdDisplay: string | null = null;
  userRoleLabels: string[] = [];
  menuSections: SidebarSection[] = [];
  constructor(private hyginestaft: HygieneStaftReportService) { }
  /** System-based menu: sections and links (can later be loaded from a service) */
  // readonly menuSections: SidebarSection[] = [
  //   {
  //     title: 'Reports',
  //     items: [
  //       { path: '/building-image-data', label: 'Building Image Data', icon: 'fa fa-building' },
  //       { path: '/hygieneStaffAttendance', label: 'Hygiene / StaffAttendance', icon: 'fa fa-file-medical-alt' },
  //        { path: '/hygiene-day-wise-report', label: 'Hygiene Day Wise', icon: 'fa-solid fa-calendar-days' },
  //       { path: '/hygine-cleaning', label: 'Hygiene / Activity', icon: 'fa fa-broom' },       
  //       { path: '/ticketingStaffAttendance', label: 'Ticketing / Report', icon: 'fa fa-ticket-alt' },

  //     ]
  //   },
  // ]
  // PATH_MAP: { [key: number]: string } = {
  //   136: '/building-image-data',
  //   137: '/hygieneStaffAttendance',
  //   138:'/hygine-cleaning',
  //   139:'/ticketingStaffAttendance'
  // };

  ngOnInit() {
    this.payrollIdDisplay = this.hyginestaft.getStoredPayrollId();
    this.menuSections = [];
    this.loadMenu();
  }

  onMouseEnter(): void {
    if (this.collapseTimer) {
      clearTimeout(this.collapseTimer);
      this.collapseTimer = null;
    }
    if (typeof window !== 'undefined' && window.innerWidth >= 800) {
      document.body.classList.add('sidebar-hovered');
    }
  }

  onMouseLeave(): void {
    if (this.collapseTimer) clearTimeout(this.collapseTimer);
    this.collapseTimer = setTimeout(() => {
      document.body.classList.remove('sidebar-hovered');
      this.collapseTimer = null;
    }, this.collapseDelayMs);
  }
  //   private fallbackReportsSection(): SidebarSection {
  //   return {
  //     title: 'Reports',
  //     items: [
  //       { path: '/hygiene-report', label: 'Hygiene / Report', icon: 'fa fa-file-medical-alt' },
  //       { path: '/hygiene-cleaning', label: 'Hygiene Cleaning', icon: 'fa fa-broom' },
  //       { path: '/hygiene-day-wise-report', label: 'Hygiene Day Wise', icon: 'fa-solid fa-calendar-days' },
  //       { path: '/building-image-data', label: 'Building Image Data', icon: 'fa fa-building' }
  //     ]
  //   };
  // }
  loadMenu(): void {
    this.hyginestaft.getUserRolesCached().subscribe({
      next: (res: any) => {
        const flatRoles = this.hyginestaft.parseUserRolesPayload(res);
        const groups = res?.userAppForms ?? res?.data?.userAppForms ?? [];
        const buildingGroup = Array.isArray(groups)
          ? groups.find((g: any) => g?.formGroup === 'BUILDING_MAINTENANCE')
          : null;

        if (!buildingGroup?.appForms?.length) {
          this.userRoleLabels = flatRoles;
          this.menuSections = [];
          return;
        }

        const items: SidebarItem[] = (buildingGroup.appForms as any[]).map((form: any) => ({
          path: this.pathForForm(form),
          label: String(form?.appFormLabel ?? form?.appFormName ?? 'Item'),
          icon: this.getIcon(String(form?.appFormName ?? ''))
        }));

        this.userRoleLabels = flatRoles.length ? flatRoles : items.map((i) => i.label).filter(Boolean);
        this.menuSections = [
          {
            title: String(buildingGroup.formGroupLabel ?? 'Building maintenance'),
            items
          }
        ];
      },
      error: () => {
        this.userRoleLabels = [];
        this.menuSections = [];
      }
    });
  }
  getIcon(appFormName: string): string {
    switch (appFormName) {
      case 'BUILDING_IMAGE_DATA':
        return 'fa fa-building';
      case 'HYGIENE_STAFF_ATTENDANCE':
        return 'fa fa-file-medical-alt';
      case 'HYGIENE_ACTIVITY':
        return 'fa fa-broom';
      case 'HYGIENE_DAY_WISE':
      case 'HYGIENE_DAY_WISE_REPORT':
        return 'fa-solid fa-calendar-days';
      case 'TICKETING_REPORT':
        return 'fa fa-ticket-alt';
        case 'HYGIENE_LIVE_UPDATE':
          return 'fa fa-sync-alt';
      case 'HOUSEKEEPING_COMMAND_CENTRE':
        return 'fa fa-tachometer-alt';
      case 'HOUSEKEEPING_DASHBOARD':
        return 'fa fa-chart-line';
      default:
        return 'fa fa-circle';
    }
  }
  private readonly pathByFormId: Record<number, string> = {};
  private pathForForm(form: any): string {
    const id = Number(form?.appFormId);
    if (Number.isFinite(id) && this.pathByFormId[id]) {
      return this.pathByFormId[id];
    }
    const name = String(form?.appFormName ?? '').trim();
    if (name) {
      const mapped = this.pathByFormName[name] ?? this.pathByFormName[name.toUpperCase()];
      if (mapped) {
        return mapped;
      }
    }
    const label = String(form?.appFormLabel ?? '').trim().toLowerCase();
    if (label.includes('live update')) {
      return '/housekeeping-dashboard';
    }
    return '/';
  }
  private readonly pathByFormName: Record<string, string> = {
    BUILDING_IMAGE_DATA: '/building-image-data',
    HYGIENE_STAFF_ATTENDANCE: '/hygieneStaffAttendance',
    HYGIENE_DAY_WISE: '/hygiene-day-wise-report',
    HYGIENE_ACTIVITY: '/hygine-cleaning',
    TICKETING_REPORT: '/ticketingStaffAttendance',
    HYGIENE_LIVE_UPDATE: '/housekeeping-dashboard',
    HOUSEKEEPING_COMMAND_CENTRE: '/house-keeping-command-centre',
    HOUSEKEEPING_DASHBOARD: '/housekeeping-dashboard',
  };
}
